




































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import ui from '@/store/modules/ui';
import Login from '@/components/Checkout/UserStep/Login.vue';
import ForgotPassword from '@/components/Checkout/UserStep/ForgotPassword.vue';
import Registration from '@/components/Checkout/UserStep/Registration.vue';
import Sidebar from '@/components/UI/Sidebar.vue';
import CmsBlock from '@/components/Cms/Block.vue';
import CartHeader from '@/components/Commons/Header.vue';
import CartFooter from '@/components/Commons/Footer.vue';
import { CartItem as CartItemModel, Totals } from '@/store/models';
import cart from '@/store/modules/cart';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
  components: {
    Sidebar,
    Login,
    ForgotPassword,
    Registration,
    CmsBlock,
    CartHeader,
    CartFooter,
  },
})
export default class LoginView extends Vue {

  private mode: string = 'registered';

  get items(): CartItemModel[] {
    return cart.cart.items;
  }


  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get isGuest(): boolean {
    return this.mode === 'guest';
  }

  get isRegistered(): boolean {
    return this.mode === 'registered';
  }

  private setMode(mode: string) {
    this.mode = mode;
  }

  private openRegister() {
    ui.pushSidebar('register');
  }

  private checkoutAsGuest() {
    this.setMode('guest');
    this.$router.push({ path: '/checkout' });
  }

  get isDevelop(): boolean {
    return (process.env.NODE_ENV === 'development') ? true : false;
  }
}
